export enum ScreenNamesEnum {
  forwardCalendar = 'forward-calendar',
  obligorCusip = 'obligor-cusip'
}
